var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-medium vuw-mb-2"},[_c('span',[_vm._v(_vm._s(_vm.formatString(_vm.labels.numberOfResults, [_vm.searchResultsCount])))])])}
var staticRenderFns = []

export { render, staticRenderFns }